import {
  subscribe,
  broadcast,
  TEventSubscribeHandler,
  TEventUnsubscribeHandler,
} from '@gem/modules/eventBus';

function getBusStation(): string {
  return 'start-quote';
}

export const subscribeStartQuote = (callback: TEventSubscribeHandler): TEventUnsubscribeHandler => {
  return subscribe(getBusStation(), callback);
};

export const broadcastStartQuote = (): void => {
  broadcast(getBusStation());
};
